import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-outdoor-tickets',
  templateUrl: './outdoor-tickets.component.html',
  styleUrls: ['./outdoor-tickets.component.scss']
})
export class OutdoorTicketsComponent implements OnInit {

	bannerrequest: any = {};
	bannerList: any = "";
	cricketsList: any = "";
	presidentgeneralList: any = "";

  constructor(private allpagesService: AllPageService,) { }

  slideoutdoorcinemaConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 1,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
  ngOnInit() {

	this.loadBanner(); 
	this.allpagesService.getCricketevent().then((data) => {
		this.cricketsList = data;
		//this.presidentgeneralList = data;
		console.log(this.cricketsList);
		setTimeout(() => {
			jQuery(".ticket-name").click(function () {
				if (jQuery(this).hasClass('active')) {
					// do nothing
				} else {
					var tabid = jQuery(this).attr('id');
					jQuery(".ticket-name").removeClass('active');
					jQuery(this).addClass('active');
					jQuery(".ticket-main-content").removeClass('active');
					jQuery("#" + tabid + "-content").addClass("active");;
				}
				return false;
			});
			
		}, 1000);
	});

	
  }

  loadBanner() {
	this.bannerrequest = {
		title: "Outdoor Tickets"
	};
	let request = Object.assign({}, this.bannerrequest);
	this.allpagesService.getBannerList(request).then((data: any) => {
		this.bannerList = data.data[0];
		//console.log(this.bannerList);
	});
}

}
